const baseURI = '/external/api';

const RestEndPoints = {
  ORDERS: `${baseURI}/broker_stub_order_book`,
  PLACE_ORDER: `${baseURI}/broker_stub_place_order`,
};

export default RestEndPoints;
